import {
  getCreateLegalRepresentativeDto,
  getCreateSignupDto,
} from '@bcba/validators';

const {
  CompanyDataDto: _CompanyDataDto,
  CompanyUserDataDto: _CompanyUserDataDto,
  CompanyLegalRepresentativeDataDto: _CompanyLegalRepresentativeDataDto,
  CreateSignupDto: _SignupDto,
} = getCreateSignupDto();

const _CreateLegalRepresentativeDto = getCreateLegalRepresentativeDto();

export class CompanyDataDto extends _CompanyDataDto {}
export class CompanyUserDataDto extends _CompanyUserDataDto {}
export class CompanyLegalRepresentativeDataDto extends _CompanyLegalRepresentativeDataDto {}
export class CreateLegalRepresentativeDto extends _CreateLegalRepresentativeDto {}
export class CreateSignupDto extends _SignupDto {}
